import React, { forwardRef, ReactElement, ReactNode } from 'react';

import * as Icons from './IconList';
import { allIconNames } from './util';

export type IconName = keyof typeof Icons;

interface IconProps {
    color?: string;
    size?: string | number;
    className?: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const makeIcon = (iconName: IconName) =>
    // eslint-disable-next-line react/display-name
    forwardRef(
        (
            { color = 'inherit', size = '24px', className, ...props }: IconProps,
            ref: React.Ref<SVGSVGElement>,
        ): JSX.Element => {
            const Icon = Icons[iconName];
            return (
                <Icon
                    htmlColor={color}
                    className={className}
                    style={{ fontSize: size, verticalAlign: 'middle' }}
                    size={typeof size === 'number' ? size : parseInt(size, 10)}
                    {...props}
                    ref={ref}
                />
            );
        },
    );

type IconDict = {
    [k in IconName]: (props: IconProps) => ReactElement | ReactNode | null | undefined;
};

const Icon = (): IconDict => {
    const iconDict: IconDict = {} as IconDict;
    for (const iconName of allIconNames) {
        iconDict[iconName] = makeIcon(iconName);
    }
    return iconDict;
};

export default Icon();
